import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var getBreakpointsByProps = function getBreakpointsByProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$props = _ref.props,
      props = _ref$props === void 0 ? {} : _ref$props;

  var breakpoints = props.theme.breakpoints;
  return breakpoints;
};

getBreakpointsByProps.HELPER_ID = 'Gearz.ThemeManager.getBreakpointsByProps';
getBreakpointsByProps.returnType = PropTypes.shapeWithDescription({
  NAME_OF_BREAKPOINT: PropTypes.shapeWithDescription({
    suffix: PropTypes.stringWithDescription('String used to identify the breakpoint. It will be used to generate the props by breakpoint.'),
    columns: PropTypes.numberWithDescription('Number of columns to be configured in the grid.'),
    rowGap: PropTypes.numberWithDescription('Separation (in pixels) of each row of the grid.'),
    columnGap: PropTypes.numberWithDescription('Separation (in pixels) of each column of the grid.'),
    dimensions: PropTypes.shapeWithDescription({
      from: PropTypes.number,
      to: PropTypes.number
    }, 'Object with from (minWidth) and to (maxWidth) dimensions (in pixels) of the breakpoint.')
  }, 'Breakpoint')
}, 'Breakpoints defined by the theme.');
getBreakpointsByProps.parameterTypes = {
  parameter: PropTypes.shapeWithDescription({
    props: PropTypes.objectWithDescription('Props of the component.')
  }, 'Object with the props of the component.')
};
getBreakpointsByProps.defaultParameters = {
  parameter: {
    props: {}
  }
};

export { getBreakpointsByProps as default };
